import { useEffect, useState } from "react";
import "./StagingBanner.scss";

const isStaging = process.env.REACT_APP_API_BASE_URL?.includes("stage.");
const API_BASE = process.env.REACT_APP_API_BASE_URL ?? "";

export const StagingBanner = (): JSX.Element | null => {
  const [database, setDatabase] = useState<string | null>(null);

  useEffect(() => {
    fetch(`${API_BASE}api/v1/environment`)
      .then((r) => r.json())
      .then((data) => setDatabase(data.database))
      .catch(() => null);
  }, []);

  if (!isStaging) return null;

  return (
    <div className="staging-banner">
      STAGING{database ? ` — db: ${database}` : ""}
    </div>
  );
};
